import getAccountSourceListStore from '../store/accountSourceListStore';
import type { AccountSource } from '../store/schema/AccountSourceList';
import isFirstPartyAccountSourceType from './isFirstPartyAccountSourceType';

export function getAllGroupsAccountSources(): AccountSource[] {
    return getAccountSourceListStore().sources.filter(source =>
        isFirstPartyAccountSourceType(source.sourceType)
    );
}
